// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"49":"ba4cfd1d","132":"6b563eba","153":"b983879b","672":"de6c2e9b","701":"908431cc","890":"8d047e38"}[chunkId] + ".css";
};